function rad(d) {
  return (d * Math.PI) / 180.0
}

// 根据经纬度计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function getFlatternDistance(lat1, lng1, lat2, lng2) {
  var radLat1 = rad(lat1)
  var radLat2 = rad(lat2)
  var a = radLat1 - radLat2
  var b = rad(lng1) - rad(lng2)
  var s =
    2 *
    Math.asin(
      Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2))
    )
  s = s * 6378.137 // EARTH_RADIUS;
  // 输出为公里
  s = Math.round(s * 10000) / 10000

  var distance = s
  var distance_str = ''

  if (parseInt(distance) >= 1) {
    // distance_str = distance.toFixed(1) + "km";
    distance_str = distance.toFixed(2)
  } else {
    // distance_str = distance * 1000 + "m";
    // distance_str = (distance * 1000).toFixed(2) + "m";
    distance_str = (distance * 1000).toFixed(2)
  }

  //s=s.toFixed(4);

  // console.info('距离是', s);
  // console.info('距离是', distance_str);
  // return s;

  //小小修改，这里返回对象
  // let objData = {
  // 	distance: distance,
  // 	distance_str: distance_str
  // }
  // return objData
  //小小修改，这里返回米
  return distance_str
}
const PI = 3.1415926535897932384626
const a = 6378245.0 //卫星椭球坐标投影到平面地图坐标系的投影因子。
const ee = 0.00669342162296594323 //椭球的偏心率。

//转化经度
function transformlng(lng, lat) {
  let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
  ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0
  ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0
  ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0
  return ret
}

//转化纬度
function transformlat(lng, lat) {
  let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
  ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0
  ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0
  ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0
  return ret
}
//判断时候在国内还是国外
function out_of_china(lon, lat) {
  if (lon < 72.004 || lon > 137.8347) {
    return true
  }
  if (lat < 0.8293 || lat > 55.8271) {
    return true
  }
  return false
}
//wgs84 to gcj02   地球坐标系 转 火星坐标系
export function wgs84togcj02(lng, lat) {
  let dlat = transformlat(lng - 105.0, lat - 35.0)
  let dlng = transformlng(lng - 105.0, lat - 35.0)
  let radlat = (lat / 180.0) * PI
  let magic = Math.sin(radlat)
  magic = 1 - ee * magic * magic
  let sqrtmagic = Math.sqrt(magic)
  dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
  dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
  let mglat = lat + dlat
  let mglng = lng + dlng

  return [mglng, mglat]
}

//gcj02 to wgs84  火星坐标系 转 地球坐标系
export function gcj02towgs84(lng, lat) {
  const originalLngSign = Math.sign(lng)
  const originalLatSign = Math.sign(lat)
  lat = Math.abs(lat)
  lng = Math.abs(lng)
  let dlat = transformlat(lng - 105.0, lat - 35.0)
  let dlng = transformlng(lng - 105.0, lat - 35.0)
  let radlat = (lat / 180.0) * PI
  let magic = Math.sin(radlat)
  magic = 1 - ee * magic * magic
  let sqrtmagic = Math.sqrt(magic)
  dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
  dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
  let mglat = lat + dlat
  let mglng = lng + dlng
  let lngs = lng * 2 - mglng
  let lats = lat * 2 - mglat
  let finalLng = originalLngSign * lngs
  let finalLat = originalLatSign * lats

  return [finalLng, finalLat]
}
// 将GCJ-02(火星坐标)转为百度坐标(DB-09):
export function gcj02toBaidu(latitude, longitude) {
  var pi = (3.14159265358979324 * 3000.0) / 180.0

  var z = Math.sqrt(longitude * longitude + latitude * latitude) + 0.00002 * Math.sin(latitude * pi)
  var theta = Math.atan2(latitude, longitude) + 0.000003 * Math.cos(longitude * pi)
  var a_latitude = z * Math.sin(theta) + 0.006
  var a_longitude = z * Math.cos(theta) + 0.0065

  return { latitude: a_latitude, longitude: a_longitude }
}
